import { render, staticRenderFns } from "./IdUpload.vue?vue&type=template&id=4f8fed1a&scoped=true"
import script from "./IdUpload.vue?vue&type=script&lang=js"
export * from "./IdUpload.vue?vue&type=script&lang=js"
import style0 from "./IdUpload.vue?vue&type=style&index=0&id=4f8fed1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8fed1a",
  null
  
)

export default component.exports